import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { LongDateTime } from './long-date-time';
import { NumberCommaPipe } from './number-comma.pipe';
import { CleanDatePipe } from './clean-date.pipe';
import { SimpleDateTimePipe } from './simple-date-time.pipe';
import { SimpleDatePipe } from './simple-date.pipe';
import { ShortDateTime } from './short-date-time';
import { HasPartialTypeStringPipe } from './has-partial-type-string.pipe';
import { RemovePartialTypeStringPipe } from './remove-partial-type-string.pipe';
import { FormatPercentValPipe } from './format-percent-val';
import { AgePipe } from './age.pipe';
import { OrderByPipe } from './order-by.pipe';
import { GetPropertyPipe } from './get-property.pipe';
import { JoinPipe } from './join.pipe';
import { HtmlToStringPipe } from './html-to-string.pipe';
import { RemoveIdPipe } from './remove-id.pipe';
import { RemoveFromArrayPipe } from './remove-from-array.pipe';
import { StudentMsdNumberOnlyPipe } from './student-msd-number-only';
import { RemoveDuplicateNamesPipe } from './remove-duplicate-names.pipe';
import { ResolveRegionalNonRegionalPipe } from './resolve-regional-non-regional.pipe';
import { NullToEmptyPipe } from './null-to-empty.pipe';

const components = [
    LongDateTime,
    NumberCommaPipe,
    CleanDatePipe,
    FormatPercentValPipe,
    SimpleDateTimePipe,
    SimpleDatePipe,
    ShortDateTime,
    AgePipe,
    HasPartialTypeStringPipe,
    RemovePartialTypeStringPipe,
    OrderByPipe,
    GetPropertyPipe,
    JoinPipe,
    RemoveFromArrayPipe,
    StudentMsdNumberOnlyPipe,
    RemoveIdPipe,
    RemoveDuplicateNamesPipe,
    ResolveRegionalNonRegionalPipe,
    HtmlToStringPipe,
    NullToEmptyPipe
];

@NgModule({
    declarations: [components],
    exports: [components],
    imports: [CommonModule],
    providers: [TitleCasePipe, components]
})
export class PipesModule {}
